import angular from 'angular';
import CartPageController from "./cartpage-controller";
import VoucherController from "./voucher-controller";


let CartPage = angular
    .module('CartPage', [])
    .controller('CartPageController', CartPageController)
    .controller('VoucherController', VoucherController);

export default CartPage;


